import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../../toolkit/uicomponent';

import { BaseContext } from '../../../../../../utils/basecontext';
import { ImageLoaderComponent } from '../../../../../toolkit/imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss';
import { ToneCardImageLoaderCSSStyleImpl } from '../tonecard/tonecardimageloadercss';
import { ToneEvenCardImageLoaderCSSStyleImpl } from '../tonecard/toneevencardimageloader';
import { ArtistToneCardComponentProps, ArtistToneCardComponentState, ArtistToneCardComponentHandler } from './artisttonecardcomponent';
import { ToneCardCSSStyle } from '../tonecard/tonecardcssstyle';
import './artistsearch-style.css';
import { ToneMobileCardImageLoaderCSSStyleImpl } from '../tonecard/tonemobilecardimageloadercss';
import { ToneMobileEvenCardImageLoaderCSSStyleImpl } from '../tonecard/tonemobileevencardimageloader';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
// import { RoutingFeatures } from '../../../../navigation/routingfeature';

export class ArtistToneCardViewImpl extends UIComponentViewImpl<UIDataModel> 
{
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private mobileImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private mobileEvenImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenImageLoaderCSSStyle: ImageLoaderCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
      
        this.imageLoaderCSSStyle = new ToneCardImageLoaderCSSStyleImpl(context);
        this.mobileImageLoaderCSSStyle = new ToneMobileCardImageLoaderCSSStyleImpl(context);
        this.evenImageLoaderCSSStyle = new ToneEvenCardImageLoaderCSSStyleImpl(context);
        this.mobileEvenImageLoaderCSSStyle = new ToneMobileEvenCardImageLoaderCSSStyleImpl(context);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
    }
     

    draw(props: ArtistToneCardComponentProps, state: ArtistToneCardComponentState, cssStyle: ToneCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
                <div id="artistsearch-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                <div id="artistsearch-col2-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                <div id="artistsearch-col-wrapper">
                    {
                        this.getMobileView(props, state, cssStyle)
                    }
                </div>
            </>
        );
    }

    getWebView(props: ArtistToneCardComponentProps, state: ArtistToneCardComponentState, cssStyle: ToneCardCSSStyle):JSX.Element
    {
        return(
            <>
                 <div  id="artistsearch-main-wrapper" onClick={this.onSelected} key={props.position} style={props.cardStyle.getToneWrapperCSSStyle(props.marginTop)}>
                    {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenImageLoaderCSSStyle} context={props.context}/>}
                <div style={props.cardStyle.getDetailsDivCssStyle()}>
                   
                   <div style={props.cardStyle.getTitleDivCSSStle()}>
                     <div id="artistsearch-name-label-div" style={{height: "30px", overflow: "hidden",marginTop:'20px',marginBottom:'3px'}}>
                        <label id="artistsearch-name-label" title={props.toneDto.getArtistName()} style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                 </div>
                 <div style={cssStyle.getButtonCSSStyle()} onClick={this.onSelected}>
                         <img  src={this.getUIProps().context.getResources().getImage("eye.svg")} width='24px' height='100%'/>
                        <label id="artist-view-tone-card-option-label">{this.getContext().getResources().getString(Strings.view)}</label>
                         {/* <div style={{width:'24px', height:'100%',marginRight:'0px'}}>
                        </div> */}
                    </div>
            </div>
            </>
        );
    }
    getMobileView(props: ArtistToneCardComponentProps, state: ArtistToneCardComponentState, cssStyle: ToneCardCSSStyle):JSX.Element
    {
        return(
            <>
                 <div id="artistsearch-main-wrapper" onClick={this.onSelected} key={props.position} style={props.cardStyle.getMobileToneWrapperCSSStyle(props.marginTop)}>
                    {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.mobileImageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.mobileEvenImageLoaderCSSStyle} context={props.context}/>}
                <div style={{objectFit: 'cover', height: '22px',display: "flex", position: "relative", flexDirection: "row",flexFlow: "row wrap", backgroundColor: this.getUIProps().context.getResources().getColor(Colors.color_5)}}>
                   
                   <div style={{height: '22px', flex: 1}}>
                     <div id="artistsearch-name-label-div" style={{height: "30px",overflow: "hidden",marginTop:'10px',marginBottom:'3px'}}>
                        <label id="artistsearch-name-label" title={props.toneDto.getArtistName()} style={props.cardStyle.getMobileToneNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                 </div>
                 <div style={cssStyle.getMobileButtonCSSStyle()}  onClick={this.onSelected}>
                        <img  src={this.getUIProps().context.getResources().getImage("eye.svg")} width='20px' height='20px'/>
                    <label id="artist-view-tone-card-option-label">{this.getContext().getResources().getString(Strings.view)}</label>
                         {/* <div style={{width:'20px', height:'20px',marginRight:'0px'}}>
                        </div> */}
                    </div>
            </div>
            </>
        );
    }
    getToneOptionsPart(cssStyle: ToneCardCSSStyle)
    {
        return (
            <div style={cssStyle.getOnHoverCSSStyle()}/>);
    }

    protected onSelected()
    {
        (this.getUIComponentHandler() as ArtistToneCardComponentHandler).onArtistClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/artist/artisttonecardview.tsx